import React, { useState } from "react";
import { Button, Card, Col, Form, Image, Modal, Row, Tab, Tabs } from "react-bootstrap";
import xclose from "../../assets/x-close.svg";
import ResponsiveTable from "./ResponsiveTable";
import Alert from "../common/Alert";
import ExcelDownload from "./ExcelDownload";
import Loader from "../common/loader";
import "./Upload.css";
const XLSX = require('xlsx');


export default function Upload(props) {

    const [validData, setValidData] = useState([])
    const [invalidData, setInvalidData] = useState([])
    const [headers, setHeaders] = useState()
    const [file, setFile] = useState()
    const [errorMessage, setErrorMessage] = useState()
    const [loading, setLoading] = useState(false)
    const[showModal,setShowModal]=useState(false)

    const uploadFile = async () => {
        if (!file) {
            setErrorMessage("Please select file");
            return;
        }
        
        setLoading(true);
        if (props.setUploadLoading) {
            props.setUploadLoading(true);
        }
        // props.setShowUpload(false)
        setShowModal(true)
        try {
                let tempHeaders = []
                Object.assign(tempHeaders, props.headers);
                setErrorMessage();
                const data = await file.arrayBuffer();
                const workbook = XLSX.read(data);
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];


                // Process the worksheet data
                const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                let index = 0;
                let tempValidData = [];
                let tempInvalidData = [];
                let errorMsg = "";

                for (let row of rows) {
                    // console.log("row", row)
                    ++index;
                    if (index == 1) {
                        for (let columnObj of tempHeaders) {
                            let cellIndex = 0;
                            let isFound = false;
                            for (let cell of row) {
                                if (cell == columnObj.displayName) {
                                    columnObj.index = cellIndex;
                                    isFound = true;
                                    break;
                                }
                                ++cellIndex;
                            }
                            if (columnObj.required && !isFound) {
                                errorMsg = (errorMsg?.length > 0 ? errorMsg + "," : "") + " Mandatory column " + columnObj.displayName + " not present";
                            }
                        }
                    } else if (errorMsg?.length > 0) {
                        setErrorMessage(errorMsg)
                        break;

                    } else {
                        let obj = {}
                        // First pass: populate all column values into obj
                        for (let columnObj of tempHeaders) {
                            if (columnObj.uploadFormatter) {
                                let data = columnObj.uploadFormatter(row[columnObj.index], columnObj, obj);
                                if (data instanceof Array) {
                                    if (obj[columnObj.columnName] && obj[columnObj.columnName].length > 0) {
                                        obj[columnObj.columnName] = [...obj[columnObj.columnName], ...data]
                                    } else {
                                        obj[columnObj.columnName] = data;
                                    }
                                } else {
                                    obj[columnObj.columnName] = data;
                                }
                            } else {
                                obj[columnObj.columnName] = row[columnObj.index];
                            }
                        }

                        // Second pass: run validations (obj is now fully populated)
                        for (let columnObj of tempHeaders) {
                            if (columnObj.required && (row[columnObj.index] === undefined || row[columnObj.index] === null || row[columnObj.index] === "")) {
                                obj.Error = (obj.Error?.length > 0 ? obj.Error + "," : "") + columnObj.displayName + " is mandatory";
                            }

                            if (row[columnObj.index]?.length > columnObj.maxLength){
                                obj.Error = (obj.Error?.length > 0 ? obj.Error + ", " : "") + " Maximum length of " + columnObj.displayName + " is greater than " + columnObj.maxLength;
                            }

                            if (row[columnObj.index] && row[columnObj.index] != "" && ["number"].includes(columnObj.dataType)) {
                                if (typeof row[columnObj.index] !== columnObj.dataType) {
                                    obj.Error = (obj.Error?.length > 0 ? obj.Error + "," : "") + " Format of " + columnObj.displayName + " is not  " + columnObj.dataType;
                                }
                            }

                            if (columnObj.customValidation && row[columnObj.index] && row[columnObj.index] != "") {
                                let error = await columnObj.customValidation(row[columnObj.index])
                                if (error?.length > 0) {
                                    obj.Error = (obj.Error?.length > 0 ? obj.Error + "," : "") + error;
                                }
                            }
                            
                            // Check for duplicates in database
                            if (columnObj.duplicateCheck && row[columnObj.index] && row[columnObj.index] != "") {
                                let isDuplicate = columnObj.duplicateCheck(row[columnObj.index], obj);
                                if (isDuplicate) {
                                    console.log("Adding duplicate error for:", row[columnObj.index]);
                                    obj.Error = (obj.Error?.length > 0 ? obj.Error + "," : "") + columnObj.displayName + " already exists in database";
                                }
                            }
                        }

                        // Check for duplicates within the uploaded file (only for product quantity)
                        if (obj.productCode !== undefined) {
                            let isDuplicateInFile = tempValidData.some((item) => 
                                item.productCode?.toString().toLowerCase() === obj.productCode?.toString().toLowerCase() && 
                                item.gadCustomerCode?.toString().toLowerCase() === obj.gadCustomerCode?.toString().toLowerCase() &&
                                item.retailerGstin?.toString().toLowerCase() === obj.retailerGstin?.toString().toLowerCase()
                            );
                            if (isDuplicateInFile) {
                                obj.Error = (obj.Error?.length > 0 ? obj.Error + "," : "") + "Duplicate record found in uploaded file (Product Code + GAD Customer Code + Retailer GSTIN)";
                            }
                        }

                        // obj.oid = index;
                        if (obj?.Error?.length > 0) {
                            tempInvalidData.push(obj);
                        } else if (Object.keys(obj).length > 0) {
                            tempValidData.push(obj);
                        }
                    }

                }

                // Delete existing invalid data first
                if (props.handleApi) {
                    await props.handleApi();
                }

                // Parallel batch upload for large datasets
                if (tempValidData.length > 0) { 
                    const chunkSize = 30; // Fixed chunk size
                    const maxConcurrency = 5; // Limit concurrent requests
                    const chunks = [];
                    
                    // Create chunks
                    for (let i = 0; i < tempValidData.length; i += chunkSize) {
                        chunks.push(tempValidData.slice(i, i + chunkSize));
                    }
                    
                    // Process chunks in parallel with concurrency limit
                    const processChunk = async (chunk, index) => {
                        try {
                            await props.handleUpload({ 
                                validData: chunk, 
                                invalidData: index === 0 ? tempInvalidData : [],
                                chunkIndex: index,
                                totalChunks: chunks.length
                            });
                            return { success: true, chunk, index };
                        } catch (error) {
                            console.log(`Error in chunk ${index}:`, error);
                            chunk.forEach(obj => {
                                obj.Error = error.message || error;
                                tempInvalidData.push(obj);
                            });
                            return { success: false, chunk, index, error };
                        }
                    };
                    
                    // Process chunks with controlled concurrency
                    const results = [];
                    for (let i = 0; i < chunks.length; i += maxConcurrency) {
                        const batch = chunks.slice(i, i + maxConcurrency);
                        const batchPromises = batch.map((chunk, batchIndex) => 
                            processChunk(chunk, i + batchIndex)
                        );
                        const batchResults = await Promise.allSettled(batchPromises);
                        results.push(...batchResults);
                        
                        // Progress update
                        const processed = Math.min(i + maxConcurrency, chunks.length);
                        console.log(`Processed ${processed}/${chunks.length} batches`);
                    }
                    
                    // Filter out failed records
                    const failedChunks = results
                        .filter(result => result.status === 'fulfilled' && !result.value.success)
                        .map(result => result.value.chunk)
                        .flat();
                    
                    tempValidData = tempValidData.filter(obj => !tempInvalidData.includes(obj) && !failedChunks.includes(obj));
                } else if (tempInvalidData.length > 0) {
                    // Send only invalid data when no valid records exist
                    try {
                     props.handleUpload({ validData: [], invalidData: tempInvalidData });
                    } catch (error) {
                        console.log("error uploading invalid data", error);
                    }
                }

                tempHeaders.push({ displayName: "Error", columnName: "Error", dataType: "text", displayIndication: true, width: 150 })
                setHeaders(tempHeaders);
                setInvalidData(tempInvalidData)
                setValidData(tempValidData)

                if (tempValidData.length > 0 || tempInvalidData.length > 0) {
                    props.setReload();
                    // Set loading to false before showing alerts
                    if (props.setUploadLoading) {
                        props.setUploadLoading(false);
                    }
                    setShowModal(false);
                     if (tempInvalidData.length > 0) {
                         setInvalidData(tempInvalidData)
                         Alert("error", `${tempValidData.length} records uploaded successfully. ${tempInvalidData.length} invalid records found.`);
                    } else {
                        Alert("success", `${tempValidData.length} records uploaded successfully.`);
                    }
                }
        } catch (error) {
            setErrorMessage(error.toString());
            if (props.setUploadLoading) {
                props.setUploadLoading(false);
            }
        } finally {
            setLoading(false);
        }
    };

    return (<>
        {/* {loading && <Loader/>} */}
        <Modal show={props.showUpload && !showModal} {...props} size="lg" backdrop={false} className="upload">
        <Modal.Header >
            <Image src={xclose} onClick={() => props.setShowUpload(false)}></Image>
            <Modal.Title className="modal-title">
                Import File
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Row>
                <Col md={6} sm={12}>
                    <Form.Control type="file" name="file" onChange={(e) => {
                        setFile(e.target.files[0]);
                        setErrorMessage(""); // Clear error message when file is selected
                    }}></Form.Control>
                </Col>
                <Col md={6} sm={12}>
                    Download Template : <ExcelDownload fileName={props.dataType} downloadTemplate={true} headers={props.headers} data={[]} />
                </Col>
            </Row>
            <Row>
                <Col className="mt-2">
                    {errorMessage && (<Form.Text className="text-danger">{errorMessage}</Form.Text>
                    )}
                </Col>
            </Row>
            <Row className="action-btn mt-2">
                <Col lg={1} md={2} sm={6}>
                    <Button variant="btn btn-primary btn-color" type="submit" onClick={uploadFile}> Upload</Button>
                </Col>
            </Row>
             {(validData.length > 0 || invalidData.length > 0) && !errorMessage && <>
                < div className="mt-2 sub-header">File Data</div>
                <Tabs defaultActiveKey="Invalid" id="uncontrolled-tab-example">
                    <Tab eventKey="Invalid" title="Invalid Entries">
                        <Card className="card-form first">
                            <Card.Body>
                                {invalidData.length > 0 && (
                                    <div className="mb-2">
                                        <ExcelDownload 
                                            fileName={`Invalid_${props.dataType}`} 
                                            downloadData={true} 
                                            headers={headers} 
                                            data={invalidData} 
                                        />
                                    </div>
                                )}
                                <ResponsiveTable data={invalidData} headers={headers} dataType={"Invalid " + props.dataType} />
                            </Card.Body>
                        </Card>
                    </Tab>
                    <Tab eventKey="Valid" title="Uploaded Entries">
                        <Card className="card-form"><Card.Body>
                            <ResponsiveTable data={validData} headers={headers} dataType={"Valid " + props.dataType} />
                        </Card.Body></Card>
                    </Tab>
                </Tabs>
            </>}
        </Modal.Body></Modal>
    </>)
}